import { CATEGORY_DISPLAY_NAMES, CATEGORY_PATHS } from '@/config/categoryRoutes';

/**
 * Map category display names to URL paths
 * Handles multiple name variations pointing to the same path
 */
export const getCategoryPath = (categoryName: string): string => {
  // Create reverse lookup from display names
  const pathMapping: Record<string, string> = {};
  
  // Add all standard mappings from central config
  Object.entries(CATEGORY_DISPLAY_NAMES).forEach(([path, name]) => {
    pathMapping[name] = `/${path}`;
  });
  
  // Add additional name variations that map to existing paths (incl. DB names for display-only rename)
  const additionalMappings: Record<string, string> = {
    'Evenemangslokal': `/${CATEGORY_PATHS.VENUES}`,
    'Festlokal': `/${CATEGORY_PATHS.VENUES}`,
    'Smycken': `/${CATEGORY_PATHS.RINGS}`,
    'Bakverk': `/${CATEGORY_PATHS.CAKES}`,
    'Tryckeri': `/${CATEGORY_PATHS.CARDS}`,
    'Blommor': `/${CATEGORY_PATHS.BOUQUETS}`,
    'Bröllopsbil': `/${CATEGORY_PATHS.CARS}`,
    'Brudbukett': `/${CATEGORY_PATHS.BOUQUETS}`,
    'Brudfrisyrer': `/${CATEGORY_PATHS.HAIRDRESSER}`,
    'Brudmakeup': `/${CATEGORY_PATHS.MAKEUP}`,
  };

  return pathMapping[categoryName] || additionalMappings[categoryName] || '/suppliers';
};

/**
 * Map category display names to /brollopstjanster/{category} HUB 1 page paths.
 * Used for navigation dropdown links (header menu).
 */
export const getCategoryLocationPath = (categoryName: string): string => {
  // Create reverse lookup from display names
  const pathMapping: Record<string, string> = {};

  // Add all standard mappings from central config
  Object.entries(CATEGORY_DISPLAY_NAMES).forEach(([path, name]) => {
    pathMapping[name] = `/brollopstjanster/${path}`;
  });

  // Add additional name variations (incl. DB names for display-only rename)
  const additionalMappings: Record<string, string> = {
    'Evenemangslokal': `/brollopstjanster/${CATEGORY_PATHS.VENUES}`,
    'Festlokal': `/brollopstjanster/${CATEGORY_PATHS.VENUES}`,
    'Smycken': `/brollopstjanster/${CATEGORY_PATHS.RINGS}`,
    'Bakverk': `/brollopstjanster/${CATEGORY_PATHS.CAKES}`,
    'Tryckeri': `/brollopstjanster/${CATEGORY_PATHS.CARDS}`,
    'Blommor': `/brollopstjanster/${CATEGORY_PATHS.BOUQUETS}`,
    'Bröllopsbil': `/brollopstjanster/${CATEGORY_PATHS.CARS}`,
    'Brudbukett': `/brollopstjanster/${CATEGORY_PATHS.BOUQUETS}`,
    'Brudfrisyrer': `/brollopstjanster/${CATEGORY_PATHS.HAIRDRESSER}`,
    'Brudmakeup': `/brollopstjanster/${CATEGORY_PATHS.MAKEUP}`,
  };

  return pathMapping[categoryName] || additionalMappings[categoryName] || '/';
};

/**
 * Map category names to emoji icons
 */
export const getCategoryIcon = (categoryName: string): string => {
  const iconMapping: Record<string, string> = {
    'Bröllopslokaler': '🏛️',
    'Evenemangslokal': '🏛️',
    'Festlokal': '🏛️',
    'Brudklänning': '👗',
    'Vigselringar': '💍',
    'Smycken': '💍',
    'Bröllopsfotograf': '📷',
    'Videograf': '🎥',
    'Bröllopstårta': '🎂',
    'Bakverk': '🎂',
    'Bröllopskort': '💌',
    'Tryckeri': '💌',
    'Brudbukett': '💐',
    'Blommor': '💐',
    'Bröllopskostym': '🤵',
    'Catering': '🍽️',
    'Musik': '🎵',
    'Brudmakeup': '💄',
    'Brudfrisyrer': '💇‍♀️',
    'Underhållning': '🎭',
    'Bröllopsplanerare': '📋',
    'Bröllopsbil': '🚗',
    'Bröllopsbilar': '🚗',
    'Uthyrning': '🏢',
  };

  return iconMapping[categoryName] || '📋';
};
